import Container from "modules/Core/sub-modules/ui-kit/components/Container";
import Stamp from "modules/Core/sub-modules/ui-kit/components/Stamp";
import CompleteSabbaticalButton from "modules/sabbaticals/components/CompleteSabbaticalButton";
import ActivityCard from "./ActivityCard";
import CycleActivityOptions from "./CycleActivityOptions";
import styles from "./styles.module.scss";

const CycleActivity = ({
    activity = {},
    cycleId,
    refetch,
    remove,
}) => (
    <ActivityCard
        title={activity.name || "Untitled"}
        text={activity.text}
        stamps={activity.stamps}
        options={
            <CycleActivityOptions
                activity={activity}
                cycleId={cycleId}
                refetch={refetch}
                extraOptions={[{ text: "Remove", onClick: remove }]}
            />
        }
    />
)

export const CycleSabbatical = ({
    activity = {},
    cycleId,
    refetch,
}) => (
    <ActivityCard
        className={styles.sabbatical}
        title={activity.name || "Sabbatical"}
        text={activity.text}
        stamps={activity.stamps}
        headerAppendage={<Stamp nature={"success_street"} stamp="Sabbatical" />}
        options={
            <CycleActivityOptions
                activity={activity}
                cycleId={cycleId}
                refetch={refetch}
            />
        }
    >
        <Container maxWidth flex alignCenter p1>
            <CompleteSabbaticalButton
                shouldRender={Boolean(activity?.stamps?.commenced) && Boolean(activity?.stamps?.completed)}
            />
        </Container>
    </ActivityCard>
)

export default CycleActivity;
